export default __webpack_public_path__ + "static/media/BMCM_Finance_Logo.fcbb7ee8.svg";